import { css } from "./SKT";

export const SKTPanel = ({ children }) => {
  return <div className={css("panel panel-primary")}>{children}</div>;
};

export const SKTPanelHeading = ({ children }) => {
  return <div className={css("panel-heading")}>{children}</div>;
};

export const SKTPanelBody = ({ children }) => {
  return <div className={css("panel-body")}>{children}</div>;
};

export const SKTPanelFooter = ({ children }) => {
  return <div className={css("panel-footer")}>{children}</div>;
};
